module.exports = __webpack_public_path__ + "static/media/icon-settings.054087f5.svg";